export const styles = {
  global: {
    ":root": {
      "--header-height": "0px",
    },
    html: {
      WebkitFontSmoothing: "auto",
    },
    body: {
      fontFamily: "larsseit",
      fontFeatureSettings: '"ss01" on, "ss02" on',
      bg: "primary.white",
      color: "primary.midGrey",
    },
    a: {
      color: "primary.midGrey",
      textDecoration: "underline",
    },

    "h1, h2, h3, h4, strong": {
      fontFamily: "larsseit",
      fontFeatureSettings: '"ss01" on, "ss02" on',
    },
    "h1, .h1": {
      fontSize: { base: "2.5rem", md: 50 },
      fontWeight: "normal",
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
    },
    h2: {
      fontSize: { base: "1.875rem", md: 32 },
      letterSpacing: "-0.02em",
      lineHeight: { base: 1.3, md: 1.4 },
    },
    "h3, .h3": {
      fontSize: { base: "1.25rem", md: 26 },
      letterSpacing: "-0.02em",
      lineHeight: { base: 1.3, md: 1.3077 },
    },
    p: {
      fontFamily: "larsseit",
      fontFeatureSettings: '"ss01" on, "ss02" on',
      fontSize: { base: "1.125rem", sm: 20 },
      lineHeight: { base: 1.4, sm: 1.5 },
    },
    strong: {
      fontWeight: "medium",
    },

    ".small": {
      fontSize: "1rem",
      lineHeight: { base: 1.3, md: 1.5 },
      my: 3.5,
    },
    ".subtext": {
      fontSize: "1rem",
      lineHeight: { base: 1.3, md: 2.125 },
      my: 3.5,
    },

    ".content-h3": {
      fontSize: { base: "1.25rem", sm: 30 },
      lineHeight: { base: 1.3, sm: 1.4 },
    },
    ".content-p": {
      my: 3,
    },
    ".content-list": {
      mt: 4,
      ml: 10,
      mb: 6,
      p: {
        my: 0,
        pl: 2,
      },
      ol: {
        li: {
          mb: 4,
        },
      },
    },

    ".react-video video": {
      objectFit: "cover",
    },

    ".user-icon svg": {
      w: "auto",
      h: { base: "30px", sm: "36px" },
    },

    ".squiggle-underline": {
      pos: "relative",
      _after: {
        content: '""',
        display: "block",
        bg: "url(/images/underline.svg) repeat-x bottom/8px auto",
        w: "100%",
        h: 2,
        pos: "absolute",
        left: 0,
        top: "100%",
      },
    },
  },
}
